// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__RbZPL","sectionTitle":"Faq_sectionTitle__3SAzJ","sectionRead":"Faq_sectionRead__fOTbI","faqContainer":"Faq_faqContainer__3cTJA"};